/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface NotificationSendCategory
 */
export interface NotificationSendCategory {
    /**
     * 알림 전송 카테고리 id
     * @type {number}
     * @memberof NotificationSendCategory
     */
    'notificationSendCategoryId': number;
    /**
     * 카테고리
     * @type {string}
     * @memberof NotificationSendCategory
     */
    'category': NotificationSendCategoryCategoryEnum;
}

export const NotificationSendCategoryCategoryEnum = {
    Viewup: 'viewup',
    Sms: 'sms'
} as const;

export type NotificationSendCategoryCategoryEnum = typeof NotificationSendCategoryCategoryEnum[keyof typeof NotificationSendCategoryCategoryEnum];


